import { useState } from 'react'
import { Pagination as ArkPagination } from '@ark-ui/react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export function useUrlPagination(
  pageSize: number,
  prefix?: string,
): [
  ArkPagination.PageChangeDetails,
  (a: ArkPagination.PageChangeDetails) => void,
] {
  const params = new URLSearchParams(useSearchParams().toString())
  const pathname = usePathname()
  const router = useRouter()

  const paramName = prefix ? `${prefix}Page` : 'page'

  const page = parseInt(params.get(paramName) || '1')

  const [pageInfo, setPageInfo] = useState({
    page: page,
    pageSize: pageSize,
  })

  const updatePageInfoCallback = (
    newPageInfo: ArkPagination.PageChangeDetails = {
      page: 1,
      pageSize: pageSize,
    },
  ) => {
    if (newPageInfo?.page === 1) {
      params.delete(paramName)
    } else {
      params.set(paramName, newPageInfo?.page.toString())
    }

    router.push(`${pathname}?${params.toString()}`)
    setPageInfo(newPageInfo)
  }

  return [pageInfo, updatePageInfoCallback]
}
